// import config from '@gelato/config'
import sleep from '@gelato/utils/sleep';

export default function(dom, opts) {
	let options = {
		'autoplay': true,
		'hideSel': 'img',
		'minBreakpoint': null,
		...opts
	}

	init()

	function init() {
		if (options.minBreakpoint == null || isWindowLargerThanBreakpoint(options.minBreakpoint)) {
			const el = document.createElement('div')
			const tmpl = dom.querySelector('script[type="text/template"]');
			if (!tmpl) {
				return false;
			}
			el.innerHTML = tmpl.innerHTML;
			dom.appendChild(el)
			const video = el.querySelector('video');
			if (!video) {
				return false;
			}
			if (options.autoplay) {
				video.setAttribute('autoplay', true)
				video.setAttribute('muted', true)
			}

			//autoplay
			Promise.race([
				canplay(video, 3000),
				sleep(0)
			]).then(function(){
				video.style.display = 'block'
				if (options.hideSel) {
					const hideEl = dom.querySelector(options.hideSel)
					if (hideEl) {
						hideEl.style.display = 'none'
					}
				}
				if (options.autoplay) {
					setTimeout(() => {
						let prom = video.play();
						//this may be a promise and we can catch it
						if (prom) {
							prom.catch((ex) => {
								//silent fail autoplay video
							});
						}
					}, 1);
				}
			})
		}
	}

	function canplay(video, wait) {
		return new Promise(async (resolve, reject) => {
			var waited = false
			var canplay = false

			video.addEventListener('canplaythrough', () => {
				canplay = true
				if (waited) resolve()
			})

			await sleep(wait);
			waited = true;
			if (canplay) {
				resolve();
			}
		})
	}

	function isWindowLargerThanBreakpoint(bp) {
		var w = window,
			d = document,
			e = d.documentElement,
			g = d.getElementsByTagName('body')[0],
			x = w.innerWidth || e.clientWidth || g.clientWidth;

		// if (typeof bp == 'string' && config.responsive[bp] != null) {
		// 	bp = config.responsive[bp]
		// }
		return x > bp
	}
}
